import { Navigate, useLocation, useParams } from "react-router-dom";
import { getInicioCotizacion } from "../../utils/getRubro";

/**
 * El flujo de moto no tiene paso de patente (el case 0 del Cotizador de moto
 * está deshabilitado), pero /moto/cotizacion/:compania?/patente y
 * /resultado-patente siguen existiendo en historial, bookmarks y redirects
 * heredados del flujo de auto. Sin esto, esas URLs renderizan en blanco.
 */
export const RedirectInicioMoto = () => {
  const { compania } = useParams();
  const { search } = useLocation();
  return (
    <Navigate to={getInicioCotizacion("moto", compania) + search} replace />
  );
};
